import { useQuery, UseQueryResult } from 'react-query';
import { AppointmentWeek, UrlParams } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

interface IUseAppointmentWeekProps {
  start: string;
  end: string;
  coaches?: string[];
  locations?: string[];
  eventTypes?: string[];
}

function useAppointmentWeek({
  start,
  end,
  coaches,
  locations,
  eventTypes,
}: IUseAppointmentWeekProps): UseQueryResult<{ data: Array<AppointmentWeek> }> {
  const params: UrlParams = { start, end };

  if (coaches && coaches.length > 0) {
    params.coaches = coaches.join(',');
  }

  if (locations && locations.length > 0) {
    params.locations = locations.join(',');
  }

  if (eventTypes && eventTypes.length > 0) {
    params.event_types = eventTypes.join(',');
  }

  return useQuery(
    ['appointments', 'week', start, end, coaches, eventTypes, locations],
    () => client.get(`appointments/week/?${encodeUrlParams(params)}`),
    {
      enabled: !!start && !!end && (start < end || start === end),
    },
  );
}

export default useAppointmentWeek;
